import React from 'react';
import { t } from '@lingui/macro';

import { Close, MenuMain } from '@rover/icons';
import { Button } from '@rover/kibble/core';

const HamburgerIcon: React.FC = () => <MenuMain height={16} width={16} />;
const CloseIcon: React.FC = () => <Close height={16} width={16} />;

const MobileMenuButton = ({
  showMobileMenu,
  ...other
}: Record<string, any>): React.ReactElement => {
  return (
    <Button
      variant="default"
      size="small"
      display={['inline-block', 'inline-block', 'none']}
      aria-label={showMobileMenu ? t`Close` : t`Menu`}
      padding="2x"
      color="text_color_navigation"
      icon={showMobileMenu ? CloseIcon : HamburgerIcon}
      {...other}
    />
  );
};

export default MobileMenuButton;
